<template>
  <div class="accordion--item">
    <div
      class="accordion--trigger"
      :class="{ 'accordion--trigger-active': visible }"
      @click="open"
    >
      <slot name="accordion-trigger"></slot>
      <i class="far fa-chevron-down"></i>
    </div>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div v-show="visible" class="accordion--content">
        <ul>
          <slot name="accordion-content"></slot>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {},
  inject: ["Accordion"],
  data() {
    return {
      index: null
    };
  },
  computed: {
    visible() {
      return this.index == this.Accordion.active;
    }
  },
  created() {
    this.index = this.Accordion.count++;
  },
  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
    },
    start(el) {
      el.style.height = el.scrollHeight + "px";
    },
    end(el) {
      el.style.height = "";
    }
  }
};
</script>
